import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

export const WidgetRoot = styled(Card)(({ theme }) => ({
  height: '100%',
  boxShadow: 'none',
  border: `1px solid ${theme.palette.border}`,
}));

const WidgetContent = styled(CardContent)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(16),
  padding: `${theme.spacing(16, 20, 20, 20)} !important`,
  height: '100%',
}));

export const WidgetHeaderContainer = styled(CardContent)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  gap: theme.spacing(10),
  alignItems: 'center',
  padding: 0,
}));

export type WidgetProps = {
  title: string;
  headerContent?: React.ReactNode;
  children: React.ReactNode;
};

export const Widget = ({ title, headerContent, children }: WidgetProps) => {
  const shouldDisplayHeader = !!title || !!headerContent;
  return (
    <WidgetRoot role="region" aria-label={title}>
      <WidgetContent>
        {shouldDisplayHeader && (
          <WidgetHeaderContainer>
            <Typography variant="h3" color="text.secondary" pl={10}>
              {title}
            </Typography>
            {headerContent}
          </WidgetHeaderContainer>
        )}
        <Box flex={1} sx={{ position: 'relative' }}>
          <Box sx={{ position: 'absolute', inset: 0 }}>{children}</Box>
        </Box>
      </WidgetContent>
    </WidgetRoot>
  );
};
